import {Component, Optional} from '@angular/core';
import {Translatable, TranslationService} from '@ngmedax/translation';
import {DeviceService} from '../services/device.service';
import {TRANSLATION_CRUD_SCOPE} from '../../../constants';
import {KEYS} from '../../../translation-keys';


// hack to inject decorator declarations. must occur before class declaration!
export interface InitDeviceQrCodeComponent extends Translatable {}

@Component({
  selector: 'app-init-device-qr-code',
  templateUrl: './init-device-qr-code.component.html',
  styleUrls: ['./init-device-qr-code.component.css']
})
@Translatable({scope: TRANSLATION_CRUD_SCOPE, keys: KEYS})
export class InitDeviceQrCodeComponent {
  /**
   * Data for which we want a qr code image
   */
  public qrData: string;

  /**
   * Injects dependencies and initializes qr code url
   */
  public constructor(
    @Optional() private translationService: TranslationService,
    private ds: DeviceService
  ) {
    this.qrData = ds.getQrUrl();
  }

  /**
   * Hardcoded to "de_DE" for now.
   * We need to change this, when we implement multi language support
   * @type {string}
   */
  public locale = 'de_DE';
}
